import React from 'react';
import { Flex } from './shared/Flex';
import styled from 'styled-components';

const LoadingWrapper = styled(Flex)`
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(1, 6, 27, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 10px;
  z-index: 10;
`;
const Message = styled.h2`
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
  letter-spacing: 1px;
`;

const Loader = () => (
  <LoadingWrapper>
      <Message id="loading-message">{'Loading...'}</Message>
  </LoadingWrapper>
);
export default Loader;
